import React, { useEffect, useRef, useState } from "react";

const InactivityWrapper = ({ onTimeout, timeout = 300000, local, orderCount, order, hideOrderMenuItem, submitAll, onWarning }) => {

    const timerRef = useRef(null);
    const [remaining, setRemaining] = useState(timeout / 1000);
    const warningFiredRef = useRef(false);

    // keep latest props in refs
    const orderRef = useRef(order);
    const orderCountRef = useRef(orderCount);

    useEffect(() => { orderRef.current = order; }, [order]);
    useEffect(() => { orderCountRef.current = orderCount; }, [orderCount]);

    const resetTimer = () => {
        if (timerRef.current) {
            setRemaining(timeout / 1000);
            clearInterval(timerRef.current);
        }
        warningFiredRef.current = false;
        setRemaining(timeout / 1000);
        timerRef.current = setInterval(() => {
            setRemaining(prev => {
                submitAll();
                if (prev <= 10 && !warningFiredRef.current && orderCountRef.current) {
                    warningFiredRef.current = true;
                    if (onWarning) onWarning();
                }
                if (prev <= 1) {
                    if (orderRef.current) {
                        clearInterval(timerRef.current);
                        hideOrderMenuItem();
                        return timeout;
                    } else if (onTimeout) {
                        if (onTimeout())
                            clearInterval(timerRef.current);
                    }
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);
    };

    useEffect(() => {
        const events = ["mousemove", "mousedown", "keydown", "touchstart", "scroll"];
        events.forEach(e => window.addEventListener(e, resetTimer));
        resetTimer();

        return () => {
            events.forEach(e => window.removeEventListener(e, resetTimer));
            if (timerRef.current) clearInterval(timerRef.current);
        };
    }, []);

    if (remaining < 10 && orderCountRef.current)
        return (
            <div>
                <div className="kioskDialog">
                    <div className="kioskDialogContent">
                        <div className="kiosk-decrement-order">
                            {String.format(local.inactivity, remaining)}
                        </div>
                    </div>
                </div>
            </div>
        );
    else return null;
};


export default InactivityWrapper;
